import { isMatchOver, isTieBreakSet, setPointTarget } from './set-rules';

export type SetsToWinMatch = 1 | 2 | 3;

export { SET_POINTS, TIE_BREAK_POINTS, isMatchOver, isSetOver, isTieBreakSet, setPointTarget } from './set-rules';

export function clampSetsToWinMatch(value: unknown): SetsToWinMatch {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 3;
  const n = Math.round(value);
  if (n <= 1) return 1;
  if (n === 2) return 2;
  return 3;
}

/**
 * Can this score happen in a set? Past the target, play only goes on while the
 * gap stays within two points: 27-25 is valid, 250-25 is a typo.
 */
export function isReachableSetScore(us: number, them: number, setNumber: number, setsToWin: number = 3): boolean {
  const target = setPointTarget(setNumber, setsToWin);
  const top = Math.max(us, them);
  return top <= target || Math.abs(us - them) <= 2;
}

export type SkipTargetIssue = 'match_decided' | 'tie_break_not_level';

/**
 * Can play resume at `targetSet` given the scores of the sets before it? The
 * match must still be open, and the tie-break is only played at level sets.
 */
export function skipTargetIssue(
  previousSets: ReadonlyArray<{ us: number; them: number }>,
  targetSet: number,
  setsToWin: number = 3,
): SkipTargetIssue | null {
  const wonUs = previousSets.filter((s) => s.us > s.them).length;
  const wonThem = previousSets.filter((s) => s.them > s.us).length;
  if (isMatchOver(wonUs, wonThem, setsToWin)) return 'match_decided';
  if (isTieBreakSet(targetSet, setsToWin) && wonUs !== wonThem) return 'tie_break_not_level';
  return null;
}
